import React, { Component } from 'react';
import { PageHeader } from '@ant-design/pro-layout';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import { history } from '../../utils/history';
import CustomContent from './CustomContent';

class CustomAddNewPageContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleBack = () => {
    history.goBack();
  };

  render() {
    const { children } = this.props;
    const { title } = this.props;
    const { exportButton } = this.props;
    const { subTitle } = this.props;
    return (
      <CustomContent>
        <div style={{ paddingBottom: '2vh' }}>
          <PageHeader
            style={{
              border: '1px solid rgb(235, 237, 240)',
            }}
            onBack={this.handleBack}
            title={title}
            extra={exportButton || undefined}
            subTitle={subTitle}
          // subTitle="/items/addItem"
          />
        </div>
        <Card>{children}</Card>
      </CustomContent>
    );
  }
}

CustomAddNewPageContent.propTypes = {
  children: PropTypes.node,
  exportButton: PropTypes.node,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default CustomAddNewPageContent;
